import { Extension } from '@tiptap/core';

export interface InlineStyleOptions {
  /**
   * Node types that should preserve inline style attributes from HTML.
   * @default ['paragraph', 'heading', 'divWithClass']
   */
  types: string[];
}

/**
 * Preserves inline style attributes on block nodes when content is loaded
 * or pasted. E.g. <p style="color: red; margin-top: 1em"> keeps that style
 * when parsed and when serialized back to HTML.
 */
export const InlineStyle = Extension.create<InlineStyleOptions>({
  name: 'inlineStyle',

  addOptions() {
    return {
      types: ['paragraph', 'heading', 'divWithClass'],
    };
  },

  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          style: {
            default: null as string | null,
            parseHTML: (element: HTMLElement) => {
              const style = element.getAttribute('style');
              if (!style || style.trim() === '') {
                return null;
              }
              return style.trim();
            },
            renderHTML: (attributes: { style?: string | null }) => {
              const style = attributes.style;
              if (!style || style.trim() === '') {
                return {};
              }
              return { style: style.trim() };
            },
          },
        },
      },
    ];
  },
});
